import { SNIP_HANDLES, SnipHandle, handleCursor } from './support-snip-geometry';

export const STYLE_ID = 'support-snip-style';
export const ROOT_CLASS = 'support-snip';
const OVERLAY_Z_INDEX = 10000;
const DIM = 'rgba(0, 0, 0, 0.35)';
const HANDLE_PX = 10;
export const HANDLE_ATTRIBUTE = 'data-handle';

/** Zijde-offset zodat een handle gecentreerd op de 2 px-rand van het kader staat. */
const HANDLE_OFFSET = `-${HANDLE_PX / 2 + 1}px`;
const HANDLE_CENTER = `calc(50% - ${HANDLE_PX / 2}px)`;
const HANDLE_PLACEMENT: Record<SnipHandle, string> = {
  nw: `top: ${HANDLE_OFFSET}; left: ${HANDLE_OFFSET};`,
  n: `top: ${HANDLE_OFFSET}; left: ${HANDLE_CENTER};`,
  ne: `top: ${HANDLE_OFFSET}; right: ${HANDLE_OFFSET};`,
  e: `top: ${HANDLE_CENTER}; right: ${HANDLE_OFFSET};`,
  se: `bottom: ${HANDLE_OFFSET}; right: ${HANDLE_OFFSET};`,
  s: `bottom: ${HANDLE_OFFSET}; left: ${HANDLE_CENTER};`,
  sw: `bottom: ${HANDLE_OFFSET}; left: ${HANDLE_OFFSET};`,
  w: `top: ${HANDLE_CENTER}; left: ${HANDLE_OFFSET};`,
};

/**
 * Bewust neutraal en zonder thematokens: de overlay ligt over elke pagina en
 * mag er in licht en donker hetzelfde uitzien.
 */
export const STYLE = `
.${ROOT_CLASS} {
  position: fixed;
  inset: 0;
  z-index: ${OVERLAY_Z_INDEX};
  background: ${DIM};
  cursor: crosshair;
  outline: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: none;
  overflow: hidden;
  font: 14px/1.4 system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  color: #fff;
}
.${ROOT_CLASS}.has-selection {
  background: transparent;
}
.${ROOT_CLASS}.is-busy {
  cursor: progress;
}
.${ROOT_CLASS}-pill {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: calc(100vw - 32px);
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(20, 20, 20, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  transition: opacity 120ms;
  pointer-events: none;
}
.${ROOT_CLASS}.is-dragging .${ROOT_CLASS}-hint {
  opacity: 0;
}
.${ROOT_CLASS}-cancel {
  flex: none;
  padding: 2px 10px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 999px;
  background: none;
  color: inherit;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  pointer-events: auto;
}
.${ROOT_CLASS}-cancel:hover {
  background: rgba(255, 255, 255, 0.15);
}
.${ROOT_CLASS}-selection {
  position: absolute;
  box-sizing: border-box;
  border: 2px dashed #000;
  box-shadow: 0 0 0 100vmax ${DIM};
  pointer-events: none;
}
.${ROOT_CLASS}.is-adjusting .${ROOT_CLASS}-selection {
  pointer-events: auto;
  cursor: move;
}
.${ROOT_CLASS}-size {
  position: absolute;
  top: 100%;
  right: -2px;
  margin-top: 8px;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(20, 20, 20, 0.9);
  font-size: 12px;
  white-space: nowrap;
}
.${ROOT_CLASS}-handle {
  display: none;
  position: absolute;
  box-sizing: border-box;
  width: ${HANDLE_PX}px;
  height: ${HANDLE_PX}px;
  background: #fff;
  border: 1px solid #000;
  pointer-events: auto;
}
.${ROOT_CLASS}.is-adjusting .${ROOT_CLASS}-handle {
  display: block;
}
${SNIP_HANDLES.map(
  handle =>
    `.${ROOT_CLASS}-handle[${HANDLE_ATTRIBUTE}="${handle}"] { ${HANDLE_PLACEMENT[handle]} cursor: ${handleCursor(handle)}; }`,
).join('\n')}
.${ROOT_CLASS}-confirm {
  position: absolute;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 999px;
  background: rgba(20, 20, 20, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  color: #fff;
  font: inherit;
  font-size: 13px;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  pointer-events: auto;
}
.${ROOT_CLASS}-confirm:hover {
  background: rgba(50, 50, 50, 0.95);
}
.${ROOT_CLASS}-confirm:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}
.${ROOT_CLASS}.is-dragging .${ROOT_CLASS}-confirm {
  visibility: hidden;
}
.${ROOT_CLASS}-spinner {
  flex: none;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: ${ROOT_CLASS}-spin 0.8s linear infinite;
}
.${ROOT_CLASS}-live {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
@keyframes ${ROOT_CLASS}-spin {
  to { transform: rotate(360deg); }
}
`;
